import { render, staticRenderFns } from "./ModalCreateNewFolder.vue?vue&type=template&id=7af9886e"
import script from "./ModalCreateNewFolder.vue?vue&type=script&lang=js"
export * from "./ModalCreateNewFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7af9886e')) {
      api.createRecord('7af9886e', component.options)
    } else {
      api.reload('7af9886e', component.options)
    }
    module.hot.accept("./ModalCreateNewFolder.vue?vue&type=template&id=7af9886e", function () {
      api.rerender('7af9886e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalCreateNewFolder.vue"
export default component.exports